import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_mobile-app_download_nudge_dismiss-dismiss';
/**
 * On dismiss of the App Download Nudge
 */
export function trackRetailerMobileAppDownloadNudgeDismissDismiss(location_string) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { location_string },
    });
}
